import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CloudUploadSvg = function CloudUploadSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.727 4.763a4.3 4.3 0 0 0-3.152.626 4.55 4.55 0 0 0-1.91 2.661l-.161.612-.609-.088a3.8 3.8 0 0 0-1.606.11c-.522.15-1.009.409-1.43.761s-.767.79-1.018 1.286a4.197 4.197 0 0 0-.22 3.243c.182.527.466 1.01.836 1.42s.817.735 1.314.958a3.85 3.85 0 0 0 1.576.34H9.24v1.438H7.346c-.733 0-1.46-.156-2.132-.458a5.35 5.35 0 0 1-1.778-1.297 5.6 5.6 0 0 1-1.13-1.92 5.68 5.68 0 0 1 .297-4.388 5.5 5.5 0 0 1 1.377-1.74 5.3 5.3 0 0 1 1.936-1.03 5.2 5.2 0 0 1 1.585-.2 5.96 5.96 0 0 1 2.33-2.926 5.67 5.67 0 0 1 4.148-.823 5.8 5.8 0 0 1 3.593 2.29 6.1 6.1 0 0 1 1.17 3.537 4.4 4.4 0 0 1 2.229 1.474 4.65 4.65 0 0 1 1.021 3.195 4.62 4.62 0 0 1-1.382 3.047 4.35 4.35 0 0 1-3.032 1.24H14.77v-1.44h2.809c.771 0 1.514-.303 2.075-.848a3.16 3.16 0 0 0 .945-2.085 3.18 3.18 0 0 0-.698-2.186 3 3 0 0 0-1.963-1.096l-.678-.083.066-.702a4.66 4.66 0 0 0-.868-3.188 4.4 4.4 0 0 0-2.73-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.695 13.39 1.6 1.65.986-1.017-3.283-3.387-3.285 3.387.987 1.018 1.6-1.65v7.858h1.395z"
  }));
};
export var CloudUpload = function CloudUpload(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CloudUploadSvg
  }));
};